import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { toDataSourceRequestString } from '@progress/kendo-data-query';
import { Observable } from 'rxjs';
import { GridState } from '@shared';


@Injectable()
export class ConceptService {
  private apiUrl: string = environment.apiUrl + '/concept';
  constructor(private httpClient: HttpClient) {}

  getAllConcepts(state: GridState): Observable<GridDataResult> {
    return this.httpClient.get<GridDataResult>(
      `${this.apiUrl}?${toDataSourceRequestString(state)}`,
    );
  }
}
